export default "__VITE_ASSET__fa7e01c2__"